import { v4 as uuidv4 } from "uuid";
import { getBackgroundImageOptions } from "@/react/components/shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@/react/components/shared/BuilderUI/utils/buttonStyleHelpers";
import { getLineHeightOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { getFontWeightOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { defaultData as defaultP1Data } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P1BlockDefaultData";
import type {
  BaseBlock,
  BaseProp,
} from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createH3Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { defaultData as defaultH3Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Headings/H3Block/H3BlockDefaultData";
import { defaultStyles } from "./defaultStyles";

const createSectionContentTemplate = (
  taglineText: string,
  headingText: string,
  descriptionText: string,
): BaseProp => ({
  prop: "children",
  type: "children",
  value: [
    createPBlock({
      text: taglineText,
      baseData: defaultP1Data,
      styles: {
        fontWeight: getFontWeightOptions("600"),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "12",
            marginBottom: "12",
            marginLeft: "24",
            marginRight: "24",
          },
        }),
      },
    }),
    createH3Block({
      text: headingText,
      baseData: defaultH3Data,

      styles: {
        fontWeight: getFontWeightOptions("600"),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "12",
            marginBottom: "12",
            marginLeft: "24",
            marginRight: "24",
          },
        }),
      },
    }),
    createPBlock({
      text: descriptionText,
      baseData: defaultP1Data,
      styles: {
        lineHeight: getLineHeightOptions("1.6"),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "12",
            marginBottom: "12",
            marginLeft: "24",
            marginRight: "24",
          },
        }),
      },
    }),
  ],
});

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "FeatureBlock3",
  props: {
    headerContent: {
      prop: "children",
      type: "children",
      value: [],
    },
    section1Content: createSectionContentTemplate(
      "Tagline",
      "Heading",
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.",
    ),
    section2Content: createSectionContentTemplate(
      "Tagline",
      "Heading",
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.",
    ),
    section3Content: createSectionContentTemplate(
      "Tagline",
      "Heading",
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.",
    ),
    footerContent: {
      prop: "children",
      type: "children",
      value: [],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        backgroundImage: getBackgroundImageOptions(),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
